var React = require('react');
var Input = require('./../../../input');
import Checkbox from 'components/checkbox'

class Download extends React.Component {

  onChange (name, event) {
    this.props.onChange(name, (name === 'subscribe_to_news_letter') ? event.target.checked : event.target.value);
  }

  render() {
    return (
      <div className="step-container step-five">
        <h2>Almost Done!</h2>
        <p>All we need now is your email address so we can email you the HTML files for your error pages.</p>
        <Input label="Email Address"
               name="emailAddress"
               defaultValue={this.props.send_to_email_address}
               onChange={this.onChange.bind(this, 'send_to_email_address')} />
        <div className="checkbox-container">
          <Checkbox label="Yes! Send me news and offers from Statuspage about products, events, and more." onChange={this.onChange.bind(this, 'subscribe_to_news_letter')} defaultChecked={this.props.subscribe_to_news_letter} />
        </div>
        <p style={{ marginTop: '1.5rem' }}><small>By continuing, you agree to our <a href="https://dr-wac.atlassian.com/legal/privacy-policy" target="_blank">Privacy Policy</a>.</small></p>
      </div>
    )
  }

}

module.exports = Download;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/walk_through/questions/download.jsx